module.exports = require("http-proxy-middleware");


//////////////////
// WEBPACK FOOTER
// external "http-proxy-middleware"
// module id = 20
// module chunks = 0